import MasterTrack from "@/components/Library/Track/_MasterTrack";
import TrackCuePoints from "@/components/Library/Track/TrackCuePoints";
import TrackDetails from "@/components/Library/Track/TrackDetails";
import TrackHeader from "@/components/Library/Track/TrackHeader";
import TrackMenu from "@/components/Library/Track/TrackMenu";
import TrackActions from "@/components/Library/Track/TrackActions";
import TrackBranding from "@/components/Library/Track/TrackBranding";
import TrackCharts from "@/components/Library/Track/TrackCharts";
import TrackLinkBoxes from "@/components/Library/Track/TrackLinkBoxes";
import TrackConstraints from "@/components/Library/Track/TrackConstraints";

export default {
    path: '/:stationUid/tracks/:trackUid',
    props: true,
    components: {
        default: MasterTrack,
        subPageHeader: TrackHeader,
        pageActions: TrackActions,
        pageSubMenu: TrackMenu,
    },
    children: [
        {
            name: 'TrackHome', path: "details",
            components: {
                default: TrackDetails,
                subPageHeader: TrackHeader,
                pageActions: TrackActions,
                pageSubMenu: TrackMenu,
            }
        },
        {
            name: 'TrackMix', path: "mix",
            components: {
                default: TrackCuePoints,
                pageActions: TrackActions,
                subPageHeader: TrackHeader,
                pageSubMenu: TrackMenu,
            }
        },
        {
            name: 'TrackBranding', path: "branding",
            components: {
                default: TrackBranding,
                pageActions: TrackActions,
                subPageHeader: TrackHeader,
                pageSubMenu: TrackMenu,
            }
        },
        {
            name: 'TrackCharts', path: "chart",
            components: {
                default: TrackCharts,
                pageActions: TrackActions,
                subPageHeader: TrackHeader,
                pageSubMenu: TrackMenu,
            }
        },
        {
            name: 'TrackLinkBoxes', path: "Link-Boxes",
            components: {
                default: TrackLinkBoxes,
                pageActions: TrackActions,
                subPageHeader: TrackHeader,
                pageSubMenu: TrackMenu,
            }
        },
        {
            name: 'TrackConstrains', path: "constraints",
            components: {
                default: TrackConstraints,
                pageActions: TrackActions,
                subPageHeader: TrackHeader,
                pageSubMenu: TrackMenu,
            }
        }
    ]
};
